import { render, staticRenderFns } from "./GroupEnrollment.vue?vue&type=template&id=9dc85fca&scoped=true"
import script from "./GroupEnrollment.vue?vue&type=script&lang=js"
export * from "./GroupEnrollment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc85fca",
  null
  
)

export default component.exports